import React, { useState, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";

function CalendlyFormModal({
  intialOpenState = false,
  setOpenState = null,
  calendlyType = 0,
}) {
  const [isOpen, setIsOpen] = useState(intialOpenState);
  const [iframeSrc, setIframeSrc] = useState("");
  const navigate = useNavigate()

  useEffect(() => {
    if (isOpen) {


      // const script = document.createElement("script");
      // script.src = "https://link.msgsndr.com/js/form_embed.js";
      // script.async = true;
      // document.body.appendChild(script);

      return () => {
        // document.body.removeChild(script);
      };
    }
  }, [isOpen]);

  useEffect(() => {
    switch (calendlyType) {
      case 0:
        window.location.href = "tel:+416-849-5555";
        break;
      case 1:
        setIframeSrc(
          // "https://api.leadconnectorhq.com/widget/booking/jQUQfAG8LyYMk2RQ1XVM"
          "https://calendly.com/ttc55avenue/membership-appointment"
        );
        navigate(`/book-a-consultation/membership`)
        break;
      case 2:
        setIframeSrc(
          // "https://api.leadconnectorhq.com/widget/booking/hqU12jNYP0Ih0sUW5WQb"
          "https://calendly.com/ttc55avenue/women-pelvic-floor-appointment"
        );
        navigate(`/book-a-consultation/women`)
        break;
      case 3:
        setIframeSrc(
          // "https://api.leadconnectorhq.com/widget/booking/UXnsNEXRaDXX7fs2B3HJ"
          "https://calendly.com/ttc55avenue/iv-therapy-appointment"
        );
        navigate(`/book-a-consultation/iv-therapy`)
        break;
      case 4:
        setIframeSrc(
          // "https://api.leadconnectorhq.com/widget/booking/kLMBGKN0YZKBS6zDv4QS"
          "https://calendly.com/ttc55avenue/ed-treatment-appointment"
        );
        navigate(`/book-a-consultation/ed`)
        break;
      case 5:
        setIframeSrc(
        "https://calendly.com/ttc55avenue/men-pelvic-floor-appointment"
        );
        navigate(`/book-a-consultation/men`)
        break;
      case 6:
        setIframeSrc(
          "https://calendly.com/ttc55avenue/sports-medicine-appointment"
        );
        navigate(`/book-a-consultation/sports-medicine`)
        break;
      case 7:
        setIframeSrc(
          "https://calendly.com/ttc55avenue/audiology"
        );
        navigate(`/book-a-consultation/audiology`)
        break;
      case 8:
        setIframeSrc(
          "https://calendly.com/ttc55avenue/dna-clinic-appointment"
        );
        navigate(`/book-a-consultation/dna-clinic`)
        break;
      case 9:
        setIframeSrc(
          "https://calendly.com/ttc55avenue/global-medical-consulting-appointment"
        );
        navigate(`/book-a-consultation/global-medical`)
        break;
      case 10:
        setIframeSrc(
          "https://calendly.com/ttc55avenue/medical-aesthetics"
        );
        navigate(`/book-a-consultation/medical-aesthetics`)
        break;
      case 11:
        setIframeSrc(
          "https://calendly.com/ttc55avenue/aging-wellness-appointment"
        );
        navigate(`/book-a-consultation/aging-wellness`)
        break;
      case 12:
        setIframeSrc(
          "https://calendly.com/ttc55avenue/naturopathic-medicine-appointment"
        );
        navigate(`/book-a-consultation/naturopathic`)
        break;
      case 13:
        setIframeSrc(
          "https://calendly.com/ttc55avenue/orthopaedic-appointment"
        );
        navigate(`/book-a-consultation/orthopaedic`)
        break;
      default:
        
        window.location.href = "tel:+416-849-5555";
    }
  }, [calendlyType]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      if (setOpenState) setOpenState(false);
      setIsOpen(false);
    }
  };

  return (
    <div>
      {isOpen && (
        <></>
        // <div
        //   onClick={handleOverlayClick}
        //   style={{
        //     position: "fixed",
        //     inset: 0,
        //     backgroundColor: "rgba(0,0,0,0.6)",
        //     display: "flex",
        //     alignItems: "center",
        //     justifyContent: "center",
        //     zIndex: 9999,
        //   }}
        // >
        //   <div
        //     style={{
        //       backgroundColor: "#fff",
        //       borderRadius: "12px",
        //       width: "90%",
        //       maxWidth: "800px",
        //       height: "80%",
        //       overflowY: "auto",
        //       position: "relative",
        //     }}
        //   >
        //     <button
        //       onClick={() => {
        //         setIsOpen(false);
        //         if (setOpenState) setOpenState(false);
        //       }}
        //       style={{
        //         position: "absolute",
        //         top: "10px",
        //         right: "10px",
        //         background: "transparent",
        //         border: "none",
        //         fontSize: "20px",
        //         cursor: "pointer",
        //       }}
        //     >
        //       ✖
        //     </button>

        //     <iframe
        //       src={iframeSrc}
        //       style={{ width: "100%", height: "100%", border: "none" }}
        //       scrolling="no"
        //       title="Calendly Modal"
        //     />
        //   </div>
        // </div>
      )}
    </div>
  );
}

export default CalendlyFormModal;
